import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BadgePercent, ArrowRight } from "lucide-react";
import AddToCartBtn from "../../storefront/AddToCartBtn";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoreOffers() {
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/offers`).then(({ data }) => setOffers(data)).catch(() => setOffers([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8" data-testid="store-offers-page">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-11 h-11 bg-red-50 rounded-2xl flex items-center justify-center">
          <BadgePercent className="w-6 h-6 text-red-600" />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Offers &amp; Deals</h1>
      </div>
      <p className="text-sm text-slate-500 mb-6">Limited time discounts — stock khatam hone se pehle grab karein. Sab genuine, licensed store se.</p>

      {!offers ? (
        <div className="text-center py-16 text-slate-400 text-sm">Offers load ho rahe hain…</div>
      ) : offers.length === 0 ? (
        <div className="text-center py-16 bg-white border border-slate-200 rounded-3xl" data-testid="offers-empty">
          <BadgePercent className="w-10 h-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 text-sm">Abhi koi offer live nahi hai — jaldi wapas aayein!</p>
          <Link to="/store/shop" className="mt-4 inline-flex items-center gap-2 bg-[#064E3B] hover:bg-[#043B2C] text-white font-semibold px-6 py-3 rounded-full text-sm">
            Shop karein <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {offers.map((m) => (
            <div key={m.id} data-testid={`offer-card-${m.id}`} className="bg-white border border-slate-200 rounded-2xl p-3 hover:shadow-md transition-shadow relative">
              <Link to={`/store/medicine/${m.id}`} data-testid={`offer-link-${m.id}`} aria-label={`${m.name} details`} className="absolute inset-0 rounded-2xl z-0" />
              <span className="absolute top-2 left-2 z-10 bg-red-600 text-white text-[10px] font-extrabold px-2 py-1 rounded-full" data-testid={`offer-tag-${m.id}`}>
                {m.offer_type === "percent" ? `${m.offer_value}% OFF` : "DEAL"}
              </span>
              {m.image ? (
                <img src={`${process.env.REACT_APP_BACKEND_URL}${m.image}`} alt={m.name} loading="lazy" className="w-full aspect-square rounded-2xl object-cover mb-3 border border-slate-100" />
              ) : (
                <div className="w-full aspect-square rounded-2xl bg-emerald-50 flex items-center justify-center mb-3">
                  <BadgePercent className="w-10 h-10 text-emerald-600" />
                </div>
              )}
              <div className="font-semibold text-sm text-slate-900 truncate">{m.name}</div>
              <div className="text-[11px] text-slate-400 mt-0.5">{m.unit_label === "Strip" ? `Strip of ${m.pack_size}` : `1 ${m.unit_label}`}</div>
              <div className="mt-1.5 flex items-baseline gap-2">
                <span className="font-mono-num font-extrabold text-emerald-900">₹{m.offer_price.toFixed(2)}</span>
                <span className="font-mono-num text-xs text-slate-400 line-through">₹{m.mrp.toFixed(2)}</span>
              </div>
              <div className="relative z-10"><AddToCartBtn m={{ ...m, mrp: m.offer_price, in_stock: true }} testid={`offer-add-${m.id}`} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
